module.exports = __webpack_public_path__ + "static/media/ordersRetryAndSubmit.c5a3ed80.png";